<template>
  <div>
    <LoggedInLayout v-if="isLoggedIn" :guide="guide"/>
    <LoggedOutLayout v-else />
  </div>
</template>

<script>
import LoggedInLayout from "@/layouts/LoggedInLayout";
import LoggedOutLayout from "@/layouts/LoggedOutLayout";
import { mapGetters } from "vuex";
// @group Common
// Start component
export default {
  name: 'Start',
  props: {
    guide: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters("app", ["isInitialized"]),
    ...mapGetters("currentuser", ["isLoggedIn"])
  },

  components: {
    LoggedInLayout,
    LoggedOutLayout
  },

}
</script>

<style>

</style>